import { FlexBox } from '@brg/ui';
import { FC } from 'react';
import styled, { css } from 'styled-components';
import {ReactComponent as PlusSvg } from "./close.svg";
import { LayoutConst } from 'core';

type Props = {
    text: string;
    onClick?: () => void;
    isProjectEdit?: boolean;
    isCompetitionEdit?: boolean;
    reverse?: boolean;
    hideIcon?: boolean;
    disable?: boolean;
    alt?: string;
    isBookEdit?: boolean;
}

const BtnWrapper = styled(FlexBox)<{ isProjectEdit?: boolean, isCompetitionEdit?: boolean, reverse?: boolean, disable?: boolean, isProjectEditPage?: boolean, isBookEdit?: boolean }>`
    height: 32px;
    max-height: 32px;
    min-height: 32px;
    // min-width: 300px;
    width: 100%;
    max-width: 100%;
    border: 1px solid ${({ theme }) => theme.projectEdit.mobile.buttons.border};
    border-radius: 3px;
    flex-flow: ${({ reverse }) => reverse ? 'row-reverse' : 'row'};
    justify-content: center;
    place-items: center;
    text-align: center;
    background-color: ${({ theme }) => theme.projectEdit.mobile.buttons.bg};
    span {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        margin-right: ${({isProjectEditPage}) => isProjectEditPage ? 0 : '10px'};
        color: ${({ theme }) => theme.projectEdit.mobile.buttons.color}
    }
    svg {
        margin-right: ${({ reverse }) => reverse ? '13px' : 0};

        path {
            fill: ${({ theme }) => theme.projectEdit.label};
        }
    }

    ${({ disable }) => disable && css`
        pointer-events: none;
        background-color: transparent;
        border: 1px solid rgba(182, 182, 181, 1);
        color: rgba(182, 182, 181, 1);
        font-weight: 600;

        span {
            color: #B6B6B5;
        }
    `};

    ${({ isProjectEdit, isBookEdit }) => isProjectEdit || isBookEdit ? css`

    height: 48px;
    max-height: 48px;
    min-height: 48px;

    span {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 22px;
        white-space: nowrap;
        color: ${({ theme }) => theme.projectEdit.mobile.buttons.color}
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        min-width: 256px;
        height: 40px;
        max-height: 40px;
        min-height: 40px;
        span {
            font-size: 15px;
            line-height: 20px;
        }
    }

    // span {
    //     font-family: 'Inter';
    //     font-style: normal;
    //     font-weight: 400;
    //     font-size: 15px;
    //     line-height: 20px;
    //     white-space: nowrap;
    //     color: ${({ theme }) => theme.projectEdit.mobile.buttons.color}
    // }

    @media(max-width: 834px) {
        min-width: 269px;
        width: 100%:
    }
    ` : null};

    ${({ isCompetitionEdit }) => isCompetitionEdit && css`
        height: 38px;
        max-height: 38px;
        min-height: 38px;
        span {
            font-size: 17px;
            line-height: 22px;
            font-weight: 600;
            letter-spacing: -0.02em;
        }

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: 36px;
            max-height: 36px;
            min-height: 36px;
            span {
                font-size: 15px;
                line-height: 20px;
                font-weight: 400;
            }
        }
    `};

    &:hover {
        cursor: pointer;
    }
`;

export const ProjectAddButton: FC<Props> = ({ text, onClick, isProjectEdit, isCompetitionEdit, reverse, hideIcon, disable, alt, isBookEdit }) => (
    <BtnWrapper {...(alt ? { alt} : {})} disable={disable} className='add-button' onClick={onClick} isBookEdit={isBookEdit} isProjectEdit={isProjectEdit} isCompetitionEdit={isCompetitionEdit} reverse={reverse}>
        <span>{text}</span>
        {!hideIcon && <PlusSvg />}
    </BtnWrapper>
)import { FlexBox } from '@brg/ui';
import { FC } from 'react';
import styled, { css } from 'styled-components';
import {ReactComponent as PlusSvg } from "./close.svg";
import { LayoutConst } from 'core';

type Props = {
    text: string;
    onClick?: () => void;
    isProjectEdit?: boolean;
    isCompetitionEdit?: boolean;
    reverse?: boolean;
    hideIcon?: boolean;
    disable?: boolean;
    alt?: string;
    isBookEdit?: boolean;
}

const BtnWrapper = styled(FlexBox)<{ isProjectEdit?: boolean, isCompetitionEdit?: boolean, reverse?: boolean, disable?: boolean, isProjectEditPage?: boolean, isBookEdit?: boolean }>`
    height: 32px;
    max-height: 32px;
    min-height: 32px;
    // min-width: 300px;
    width: 100%;
    max-width: 100%;
    border: 1px solid ${({ theme }) => theme.projectEdit.mobile.buttons.border};
    border-radius: 3px;
    flex-flow: ${({ reverse }) => reverse ? 'row-reverse' : 'row'};
    justify-content: center;
    place-items: center;
    text-align: center;
    background-color: ${({ theme }) => theme.projectEdit.mobile.buttons.bg};
    span {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        margin-right: ${({isProjectEditPage}) => isProjectEditPage ? 0 : '10px'};
        color: ${({ theme }) => theme.projectEdit.mobile.buttons.color}
    }
    svg {
        margin-right: ${({ reverse }) => reverse ? '13px' : 0};

        path {
            fill: ${({ theme }) => theme.projectEdit.label};
        }
    }

    ${({ disable }) => disable && css`
        pointer-events: none;
        background-color: transparent;
        border: 1px solid rgba(182, 182, 181, 1);
        color: rgba(182, 182, 181, 1);
        font-weight: 600;

        span {
            color: #B6B6B5;
        }
    `};

    ${({ isProjectEdit, isBookEdit }) => isProjectEdit || isBookEdit ? css`

    height: 48px;
    max-height: 48px;
    min-height: 48px;

    span {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 22px;
        white-space: nowrap;
        color: ${({ theme }) => theme.projectEdit.mobile.buttons.color}
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        min-width: 256px;
        height: 40px;
        max-height: 40px;
        min-height: 40px;
        span {
            font-size: 15px;
            line-height: 20px;
        }
    }

    // span {
    //     font-family: 'Inter';
    //     font-style: normal;
    //     font-weight: 400;
    //     font-size: 15px;
    //     line-height: 20px;
    //     white-space: nowrap;
    //     color: ${({ theme }) => theme.projectEdit.mobile.buttons.color}
    // }

    @media(max-width: 834px) {
        min-width: 269px;
        width: 100%:
    }
    ` : null};

    ${({ isCompetitionEdit }) => isCompetitionEdit && css`
        height: 38px;
        max-height: 38px;
        min-height: 38px;
        span {
            font-size: 17px;
            line-height: 22px;
            font-weight: 600;
            letter-spacing: -0.02em;
        }

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: 36px;
            max-height: 36px;
            min-height: 36px;
            span {
                font-size: 15px;
                line-height: 20px;
                font-weight: 400;
            }
        }
    `};

    &:hover {
        cursor: pointer;
    }
`;

export const ProjectAddButton: FC<Props> = ({ text, onClick, isProjectEdit, isCompetitionEdit, reverse, hideIcon, disable, alt, isBookEdit }) => (
    <BtnWrapper {...(alt ? { alt} : {})} disable={disable} className='add-button' onClick={onClick} isBookEdit={isBookEdit} isProjectEdit={isProjectEdit} isCompetitionEdit={isCompetitionEdit} reverse={reverse}>
        <span>{text}</span>
        {!hideIcon && <PlusSvg />}
    </BtnWrapper>
)